import notify from "devextreme/ui/notify";
import Store from "redux/store";
import Api from "Api/Api";
const Utils = {
  $: (DomElement) => {
    return document.querySelector(DomElement);
  },
  notify: (message = "", type = "info", time = 1000) => {
    notify({ message: message, width: "auto" }, type, time);
  },
  search: (term, data) => {
    var re = new RegExp(term, "g");
    var value = data.filter((value) => {
      try {
        return value.name.match(re).length;
      } catch (error) {
        return false;
      }
    });
    return value;
  },
  filter: (filteredData, startups) => {
    var filteredSatrtupIDs = filteredData.map((data) => {
      return data.id;
    });
    var result = startups.filter((startup) => {
      return filteredSatrtupIDs.includes(startup.id);
    });
    return result;
  },
  objectToForm: (data) => {
    var formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    return formData;
  },
  processStartupData: (data, parentId) => {
    var allStartups = [];
    var ignore = ["new", "not_interested"];
    for (const key in data) {
      if (!ignore.includes(key)) {
        // for (const startup of data[key]) {
        //   startup["type"] = key;
        // }
        allStartups.push({
          startups: data[key].length ? data[key] : null,
          hasItems: false,
          type: key,
          parentId,
        });
      }
    }
    return allStartups;
  },
  getFormFields: () => {
    // function to check whether form fields are alredy stored inside the redux
    // if not store in redux after api call
    var formFields = Store.getState().formFields;
    if (Array.isArray(formFields)) {
      //fetch the form data from the API
      Api.getFormFields().then((response) => {
        if (response.status === 200) {
          // saving the filter values in the redux
          Store.dispatch({
            type: "AddFilterFields",
            payload: response.data,
          });
        }
      });
    }
  },
  getOnboardStartups: (data) => {
    return data.filter((startup) => {
      return startup.status === "onboard";
    });
  },
  highlighter: (data) => {
    if (data.highlightData) {
      // getting the dom element to be highlighted
      var toBeHighlighted = document.querySelector(
        `[data-highlight='${data.highlightData.id}']`
      );
      // activating the tab in which the element lies
      if (data.highlightData.type) {
        data.highlightData.type.split(".").forEach((tab) => {
          document.querySelector(`a[href='#${tab}']`).click();
        });
      }
      // scrolling till the element comes into view
      toBeHighlighted.scrollIntoView({
        behavior: "smooth",
      });
      // adding highlighting animation to the element
      toBeHighlighted.classList.add("highlight-animation");
      setTimeout(() => {
        toBeHighlighted.classList.remove("highlight-animation");
      }, 1000);
    }
  },
  errorMessageGenerator: (errorResponse) => {
    var errorMsg = "";
    for (var key in errorResponse) {
      errorMsg += `${key} : ${errorResponse[key]} \n`;
    }
    return errorMsg;
  },
  formNewDataDevXDatagrid: (newData, data) => {
    Object.entries(newData).forEach(([key, value]) => {
      data[key] = value;
    });
    return data;
  },
  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  },
  urlQueryBuilder(url, filters) {
    if (filters) {
      Object.keys(filters).forEach((key) => {
        url += `${key}=${encodeURIComponent(filters[key])}&`;
      });
      url = url.slice(0, -1);
    }
    return url;
  },
  addUniqueObjectToArray(masterArray, providedArray, key) {
    const existingRecords = (masterArray || []).map((element) => element[key]);
    const filteredResults = (providedArray || []).filter((element) => {
      return !existingRecords.includes(element[key]);
    });
    return filteredResults;
  },
  convertSnakeCaseToSpace(text) {
    if (text.includes('_')) {
      return text.replace(/_/g, " ")
    }
    return text;
  },
  convertToAntSelectDatasource(data, { displayExpr, valueExpr } = {}) {
    return data.map(record => {
      if (record) {
        if (typeof record === 'object') {
          return {
            value: record[valueExpr],
            label: record[displayExpr]
          }
        } else if (typeof record === "string") {
          return {
            value: record,
            label: record
          }
        }
      }
    })
  },
  sortAlphabetically(str1, str2) {
    return str1.localeCompare(str2);
  }
};
export default Utils;
